import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import TouchFeedback from '../touch-feedback/index';
import View from '../view/index';

export default class Item extends React.PureComponent {
    static propTypes = {
        className: PropTypes.string,
        prefixCls: PropTypes.string,
        icon: PropTypes.node,
        disabled: PropTypes.bool,
        firstItem: PropTypes.bool,
        activeStyle: PropTypes.object,
        style: PropTypes.object,
    };

    static defaultProps = {
        prefixCls: 'tm-context-menu',
        disabled: false,
    };

    static myName = 'ContextMenuItem';

    render() {
        const {
            children,
            className,
            prefixCls,
            icon,
            disabled,
            firstItem,
            activeStyle,
            ...restProps
        } = this.props;

        const prefix = `${prefixCls}-menu-item`;

        const cls = classnames(`${prefix}`, className, {
            [`${prefix}-disabled`]: disabled,
        });

        let activeClass = `${prefix}-active `;
        if (firstItem) {
            activeClass += `${prefix}-fix-active-arrow`;
        }

        return (
            <TouchFeedback
                disabled={disabled}
                activeClassName={activeClass}
                activeStyle={activeStyle}
            >
                <View className={cls} {...restProps}>
                    <View className={`${prefix}-container`}>
                        {icon ? (
                        // tslint:disable-next-line:jsx-no-multiline-js
                        <View Element='span' className={`${prefix}-icon`} aria-hidden="true">
                            {icon}
                        </View>
                        ) : null}
                        <View Element='span' className={`${prefix}-content`}>{children}</View>
                    </View>
                </View>
            </TouchFeedback>
        );
    }
}
